// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.copyText[data-v-6d2ed572] {\n    cursor: pointer;\n    display: flex;\n    margin: 10px auto;\n    justify-content: center;\n}\n.copyText svg[data-v-6d2ed572] {\n    width: 22px;\n}\n.copyText input[data-v-6d2ed572] {\n    border: 0;\n    outline: none;\n    background: rgba(223, 222, 222, .5);\n    width: 100%;\n    max-width: 515px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
